export default __webpack_public_path__ + "static/media/steps.efe899f7.png";